export const initialState = {
  publishPrivacyPolicy: {}
};
